import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowdropFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "6",
    fill: "none",
    viewBox: "0 0 12 6",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.237 5.697.223 1.122A.7.7 0 0 1 .06.911.54.54 0 0 1 0 .66Q0 .394.198.197A.7.7 0 0 1 .719 0h10.562q.324 0 .521.199A.64.64 0 0 1 12 .662q0 .067-.223.46L6.763 5.697a1.2 1.2 0 0 1-.357.23A1.1 1.1 0 0 1 6 6a1.1 1.1 0 0 1-.406-.073 1.2 1.2 0 0 1-.357-.23"
  }));
}
var IcArrowdropFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowdropFillNomargin));

export { IcArrowdropFillNomargin as I };
